<div class="flex flex-row items-stretch h-full text-xs rounded-lg md:block container-shadow">
  <button
    class="hover:bg-primary-200 transition-colors duration-150 w-32 xl:w-40 h-full leading-0.9 text-primary-600 border border-primary-400 rounded-lg md:rounded-r-none md:rounded-l-lg focus:outline-none md:inline"
    [ngClass]="paymentType === PaymentTypeEnum.LIABILITY ? 'font-bold bg-primary-100 hidden' : 'inline md:tracking-wide'"
    mat-ripple
    (click)="changeType(PaymentTypeEnum.LIABILITY)"
  >
    OPŁAĆ FAKTURĘ
    <br />
    <span>({{ payment.amountToPay | currency: 'PLN':'symbol':'.2-2':'pl-PL' }})</span>
  </button>
  <button
    class="hover:bg-primary-200 transition-colors duration-150 w-32 xl:w-40 h-full leading-0.9 text-primary-600 border border-primary-400 rounded-lg md:border-l-0 md:rounded-l-none md:rounded-r-lg md:inline focus:outline-none"
    [ngClass]="paymentType === PaymentTypeEnum.BALANCE ? 'font-bold bg-primary-100 hidden' : 'inline md:tracking-wide'"
    mat-ripple
    (click)="changeType(PaymentTypeEnum.BALANCE)"
  >
    SPŁAĆ SALDO
    <br />
    <span>({{ payment.balance.amountToPay | currency: 'PLN':'symbol':'.2-2':'pl-PL' }})</span>
  </button>
</div>
